module.exports = __webpack_public_path__ + "static/media/docx.1d3cbf85.png";